import basicController from "servicestack/basic.controller.properties";
import templateUrl from "emun.swatch/swatchlist-edit.htm";
import AutoQuery from "servicestack/auto-query/auto-query";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";
import $session from "servicestack/session";
import $appConfig from "servicestack/config";


export class SwatchListEditController {
  constructor(Lightbox) {
    let $ctrl = this;
    basicController(this);
    $ctrl.$session = $session;
    $ctrl.checkSwatchBusy = false;
    const id = $ctrl.listId;
		$ctrl.productSelection = {};
    $ctrl.bus = new ServiceBus();
    if (id == "create") {
      $ctrl.product = { id: "create" };
    } else {
      let options = {
        url: "QuerySwatchLists.json?Id=" + id,
        autoLoad: true,
        onLoaded(args) {
          $ctrl.list = args.first;
          if ($ctrl.list.listType.toUpperCase() == 'STOCK') {
            $ctrl.detailQuery = new AutoQuery({
              url: "QueryProducts.json?StockListId=" + id,
              hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
              orderBy: "Id",
              sortOptions: {
                SwatchId: "Id: Low to High",
                "-Id": "Id: High to Low",
                Description: "Description: A to Z",
                "-Description": "Description: Z to A",
              },
              autoLoad: true,
              pageSize: 12,
              onLoaded(detailArgs) {
                $ctrl.productSelection.productIds = [];
                detailArgs.results.forEach(function(res) {
                  $ctrl.productSelection.productIds.push(res.id);
                });
        
              }
            });
          } else {
            $ctrl.detailQuery = new AutoQuery({
              url: "QuerySwatchListDetail.json?ListId=" + id,
              hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
              orderBy: "SwatchId",
              sortOptions: {
                SwatchId: "SwatchId: Low to High",
                "-SwatchId": "SwatchId: High to Low",
                SwatchDescription: "Description: A to Z",
                "-SwatchDescription": "Description: Z to A",
                SwatchAltId1: "Alt ID 1: Low to High",
                "-SwatchAltId1": "Alt ID 1: High to Low",
                SwatchAltId2: "Alt ID 2: Low to High",
                "-SwatchAltId2": "Alt ID 2: High to Low",
              },
              autoLoad: true,
              pageSize: 12,
              onLoaded(detailArgs) {
                $ctrl.productSelection.productIds = [];
                detailArgs.results.forEach(function(res) {
                  $ctrl.productSelection.productIds.push(res.swatchId);
                });
        
              }
            });
          }
        },
      };
      $ctrl.query = new AutoQuery(options);

    }
  }
  checkSwatch() {
    let $ctrl = this;
    $ctrl.checkSwatchBusy = true;
    $ctrl.lastScan = $ctrl.scanId;
    setTimeout(function () {
      return $ctrl.bus
        .send("AddSwatchListItem", {
          swatchId: $ctrl.scanId,
          listId: $ctrl.listId,
        })
        .then(function (response) {
          $ctrl.checkSwatchBusy = false;
          $ctrl.status = response.data.status;
          $ctrl.swatch = response.data.swatch;
          $ctrl.detailQuery.load(true);
          $ctrl.scanId = "";
          $ctrl.setFocus();
        });
    }, 250);
  }

  delete(model) {
    let $ctrl = this;
    var id = model.swatchId || model.id;
    return modals
      .confirm("Are you sure?", "Delete " + id + " from list")
      .result.then(function () {
        $ctrl.bus
          .send("DeleteSwatchListItem", {
            ListId: $ctrl.listId,
            SwatchId: id,
          })
          .then(function (response) {
            $ctrl.detailQuery.load(true);
          });
      });
  }
  getImageUrl(id, size) {
    return $appConfig.productImage(id, size);
  }

}

export default {
  controller: SwatchListEditController,
  bindings: {
    listId: "@",
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
};
